import { SIGN_IN, BERATER_LOGON } from "./types/authentication-types";

export function signIn(kundenId) {
  return {
    type: SIGN_IN,
    payload: kundenId
  };
}

export function beraterLogon(user) {
  return {
    type: BERATER_LOGON,
    payload: user
  };
}
